interface IIconExportProps {
  className?: string;
}

export const IconExport = ({ className }: IIconExportProps) => (
  <svg className={className} viewBox="0 0 11 12" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 9.49998V12H0V9.49998C0 9.22498 0.225 8.99998 0.5 8.99998H10.5C10.775 8.99998 11 9.22498 11 9.49998ZM10 9.99998H9V10.5H10V9.99998ZM3.896 3.99198L5.446 2.44598L3.353 0.352981C3.159 0.158981 3.224 -1.87462e-05 3.499 0.000981254L9.485 0.0239815C9.76 0.0249815 9.985 0.250981 9.986 0.525981L9.998 6.49998C9.998 6.77498 9.84 6.84098 9.645 6.64598L7.566 4.56698L6.016 6.11298L3.896 3.99198ZM5.241 6.88398L3.12 4.76198L2.354 5.52598C2.159 5.71998 2.159 6.03798 2.353 6.23198L3.768 7.64698C3.962 7.84098 4.281 7.84198 4.476 7.64798L5.241 6.88398Z" />
  </svg>
);
